import { Button } from '@/components/forms';
import { AppShell, PageHeader, PageTitle } from '@/components/layout';
import { MockNote } from '@/components/foundations';
import { Badge, KeyValueList } from '@/components/data';
import { CONNECT_STEPS, PLUGGY_ITEM_ID } from '@/mocks/financas';
import { ConnectionCard, ConnectSteps, PluggyItemForm } from './components';

/** Conectar o Inter PF via Meu Pluggy (Open Finance) — layout de integrations.html, mock. */
export function FinConexoesPage() {
  return (
    <AppShell>
      <main className="content">
        <PageHeader subtitle="Conecte o Inter via Open Finance para organizar suas finanças." period="Outubro 2026" />
        <PageTitle title="Conexões" style={{ marginBottom: 22 }} />
        <section className="int-grid">
          <ConnectionCard icon="link" title="Conectar o Inter PF" subtitle="Via Meu Pluggy, somente leitura.">
            <div className="hr" />
            <ConnectSteps steps={CONNECT_STEPS} current={0} />
            <PluggyItemForm value={PLUGGY_ITEM_ID} />
          </ConnectionCard>
          <ConnectionCard
            icon="bank"
            iconTone="blue"
            title="Banco Inter PF"
            subtitle="Conta corrente + Cartão •••• 0597"
            status={<Badge icon="checkc">Ativo</Badge>}
            action={<Button variant="outline-navy" to="/financas/sync" icon="refresh" style={{ height: 56, padding: '0 24px' }}>Ver sincronização</Button>}
          >
            <div className="hr" />
            <KeyValueList
              flush
              items={[
                { k: 'Plano', v: 'Meu Pluggy · 1 de 5 conexões' },
                { k: 'Último sync', v: 'hoje, 07:02' },
                { k: 'Consentimento válido até', v: '23/10/2027' },
              ]}
            />
          </ConnectionCard>
          <ConnectionCard icon="card" iconTone="sky" title="Nubank" subtitle="Em breve." status={<Badge tone="neutral" style={{ marginLeft: 'auto' }}>Em breve</Badge>} />
          <ConnectionCard icon="trend" title="Investimentos" subtitle="Em breve." status={<Badge tone="neutral" style={{ marginLeft: 'auto' }}>Em breve</Badge>} />
        </section>
        <MockNote />
      </main>
    </AppShell>
  );
}
